export class ReceptionApiService {
    constructor(http) {
        this.endpoint = '/';
        this.http = http;
      //  this.patientApi = patientApi;
      }

      async getMyReception(uuid, start, end) {
        const params = { start, end };
        const response = await this.http.get(this.endpoint + 'appointmenthistory/by_employee/' + uuid, params);
        return response.data;
      }
      
      async createRecord(data, rec_uuid, method) {
        let response;
        if (method === 'post') {
          response = await this.http.post(this.endpoint + rec_uuid, data);
        } else {
          response = await this.http.put(this.endpoint + rec_uuid, data);
        }
        return response;
      }

      async getRecord(rec_uuid, org_uuid) {
        this.http.setApiKey(org_uuid);
        const response = await this.http.get(this.endpoint + rec_uuid);
        return response.data;
      }

      async getDiagnoses(search) {
        const str = search;
        const response = await this.http.get('/refbook/api/mkb10/search/', {search: str});
        return response.data;
      }

      async getRecepts(search) {
        const response = await this.http.get('/refbook/api/grls/search/', {search});
        return response.data;
      }

      async uploadFiles(files, id) {
        const headers = { 'Content-Type': 'multipart/form-data' };
        const response = await this.http.instance.post(this.endpoint + 'save_files/' + id, files, {
          headers
        });
        return response.data;
      }

      async fileList(id) {
        const response = await this.http.get(this.endpoint + 'load_file_list/' + id);
        return response.data;
      }

      async downloadFile(file, id) {
        const headers = { 'Content-Type': 'arraybuffer'};
        const params = {file};
        const response = await this.http.get(this.endpoint + 'load_file/' + id, params);
        return response;
      }

      forceFileDownload(response, file){
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file);
        document.body.appendChild(link);
        link.click();
      }

      async getAllRecords(patient_id) {
        const response = await this.http.get(this.endpoint + 'by_patient/' + patient_id);
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        return response.data.map(obj => ({ 'Дата приема': new Date(obj.date).toLocaleDateString('ru-RU', options), id: obj.id, type: obj.type, form: obj.type !== '025/у' ? true : false, data: this.serialize(obj.fields)}));
      }
      async editStatus(status, uuid) {
        const response = await this.http.post(this.endpoint + 'appoint_history/' + uuid, { status });
        return response;
      }

      async printForm(id) {
        const response = await this.http.get(this.endpoint + 'generate_file_by_template/' + id);
        return response.data;
      }
      async printCardPatient(id, org_uuid) {
        this.http.setApiKey(org_uuid);
        const response = await this.http.get(this.endpoint + 'generate_file_by_patient/' + id);
        return response.data;
      }

      serialize(data) {
        let resp;
        if (data.first_reception) {
          resp = {
            'Жалобы пациента': data['Жалобы пациента'],
            'Анамнез заболевания, жизни': data['Анамнез заболевания, жизни'],
            'Объективные данные': data['Объективные данные'],
            'Диагноз основного заболевания': data['Диагноз основного заболевания'],
            'Осложнения': data['Осложнения'],
            'Сопутствующие заболевания': data['Сопутствующие заболевания'],
            'Внешняя причина при травмах (отравлениях)': data['Внешняя причина при травмах (отравлениях)'],
            'Группа здоровья': data['Группа здоровья'],
            'Диспансерное наблюдение': data['Диспансерное наблюдение'],
          //  'Назначения (исследования, консультации)': data['Назначения (исследования, консультации)'],
            'Лекарственные препараты, физиотерапия': data['Лекарственные препараты, физиотерапия'],
            'Этапный эпикриз': data['Этапный эпикриз'] ? data['Этапный эпикриз']: '-'
          }; 
        } else if (data.first_reception === false) {
          resp = {
            'Жалобы': data['Жалобы'],
            'Данные наблюдения в динамике': data['Данные наблюдения в динамике'],
        //    'Назначения (исследования, консультации)': data['Назначения (исследования, консультации)'],
            'Лекарственные препараты, физиотерапия': data['Лекарственные препараты, физиотерапия'],
            'Этапный эпикриз': data['Этапный эпикриз'] ? data['Этапный эпикриз']: '-'
          };
        } else {
          resp = data;
        }
        return resp;
        
      }
}